module.exports = __webpack_public_path__ + "static/img/dialog_bgen.34bc06a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/dialog_bgen.png
// module id = P518
// module chunks = 1